export default __webpack_public_path__ + "static/fio-7215317622b102074d8d0db9abb9328b.png";